import * as actionTypes from './actionTypes';
import ConsoleLog from './../../hoc/ConsoleLog/ConsoleLog';

/**
* @desc actions for candidate clientProfile reducer
* @version
* @author  Lakshmikanth
* @return action and parameters
*/
export const getClientDetails = (clientId, isJobList, loggedInUser) => {
  return {
    type: actionTypes.GET_CLIENT_DETAILS,
    clientId: clientId,
    isJobList: isJobList,
    loggedInUser: loggedInUser
  };
};

export const setClientDetails = (clientDetails) => {
    return {
      type: actionTypes.SET_CLIENT_DETAILS,
      clientDetails: clientDetails
    };
};

export const signOutClientProfile = () => {
  return {
    type: actionTypes.COGNITO_LOGOUT
  };
};

export const getProfileImage = (userImageUrl, loggedInUser) => {
  return {
    type: actionTypes.GET_PROFILE_IMAGE,
    userImageUrl: userImageUrl,
    loggedInUser: loggedInUser
  };
};

export const updateProfileImage = (userImageUrl, UserImageSignedUrl) => {
  return {
    type: actionTypes.UPDATE_PROFILE_IMAGE,
    userImageUrl: userImageUrl,
    UserImageSignedUrl: UserImageSignedUrl
  };
};

export const getInterViewListCount = (recruiterId) => {
  ConsoleLog("action",recruiterId);
  return {
    type: actionTypes.GET_INTERVIEWLIST_COUNT,
    recruiterId: recruiterId
  };
};


export const setInterViewListCount = (count) => {
  // ConsoleLog("setInterViewListCount",count);
  return {
    type: actionTypes.SET_INTERVIEWLIST_COUNT,
    count: count
  };
}

export const setUploadButton = (status) => {
  return {
    type: actionTypes.SET_UPLOAD_BUTTON,
    status: status
  };
}
export const setPageDataLoss = (pageData, nextPath) => {
  return {
    type: actionTypes.SET_PAGEDATA_LOSS,
    pageData: pageData,
    nextPath: nextPath
  };
};




// WEBPACK FOOTER //
// ./src/store/actions/clientProfile.js